module.exports = __webpack_public_path__ + "static/media/pet-green-icon.4a4edcb2.svg";